import PowerConsumptionAdd from "../components/PowerConsumption/PowerConsumptionAdd";

const PowerConsumptionAddPage = () =>{
    return(
         <PowerConsumptionAdd/>
    )
}

export default PowerConsumptionAddPage;